module.exports = __webpack_public_path__ + "img/bd-wind-dru.211d40be.png";